import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home,
      meta: { title: 'Home', parent: null, icon: 'mdi-home' },
    }, {
      name: 'venduto-ordinato',
      path: '/venduto-ordinato',
      component: () => import(/* webpackChunkName: "venduto-ordinato" */ './views/VendutoOrdinato.vue'),
      meta: { showOn: ['OSV'], title: 'Venduto e ordinato', parent: null },
    }, {
      name: 'venduto',
      path: '/venduto',
      component: () => import(/* webpackChunkName: "venduto" */ './views/VendutoOrdinato.vue'),
      meta: { showOn: ['NRM', 'FOSV'], title: 'Venduto', parent: null },
    }, {
      name: 'Articoli',
      path: '/articoli',
      component: () => import(/* webpackChunkName: "articoli" */ './views/Articoli.vue'),
      meta: { title: 'Articoli', parent: null },
    }, {
      name: 'Storni',
      path: '/storni',
      component: () => import(/* webpackChunkName: "articoli" */ './views/Storni.vue'),
      meta: { title: 'Storni', parent: null },
    }, {
      name: 'Totali',
      path: '/totali',
      component: () => import(/* webpackChunkName: "articoli" */ './views/Totali.vue'),
      meta: { title: 'Totali', parent: null },
    }, {
      name: 'profile',
      path: '/profilo',
      component: () => import(/* webpackChunkName: "profilo" */ './views/Profile.vue'),
      meta: { title: 'Profilo' },
    },
    { path: '*', redirect: '/' },
  ],
});

export default router;
